var SalesTypeCodeEnum;
(function (SalesTypeCodeEnum) {
    SalesTypeCodeEnum["aisleAndBin"] = "AISLE_AND_BIN";
    SalesTypeCodeEnum["department"] = "DEPARTMENT";
    SalesTypeCodeEnum["contactStaff"] = "CONTACT_STAFF"; // WAREHOUSE - Prev full_serve/dds
})(SalesTypeCodeEnum || (SalesTypeCodeEnum = {}));
export default SalesTypeCodeEnum;
//# sourceMappingURL=SalesTypeCodeEnum.js.map